module.exports = __webpack_public_path__ + "static/media/whatsapp_fundo_claro.88ca0c80.png";